import React from "react";

const Search = (props: any) => {
  return (
    <svg width={18} height={18} fill="none" {...props}>
      <path
        stroke="var(--color-icon-bright)"
        d="M8.625 15.75a7.125 7.125 0 1 0 0-14.25 7.125 7.125 0 0 0 0 14.25ZM16.5 16.5 15 15"
      />
    </svg>
  );
};

export default Search;
